import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-15e49bbb")

_pushScopeId("data-v-15e49bbb")
const _hoisted_1 = { class: "container popup-container" }
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { class: "user-title" }
const _hoisted_4 = { class: "user-content" }
const _hoisted_5 = { class: "user-content-name" }
const _hoisted_6 = { class: "user-content-card" }
const _hoisted_7 = { autocomplete: "off" }
const _hoisted_8 = /*#__PURE__*/_createVNode("input", {
  autocomplete: "false",
  name: "hidden",
  type: "text",
  style: {"display":"none"}
}, null, -1)
const _hoisted_9 = { class: "user-content-card-double-row" }
const _hoisted_10 = { class: "user-card-item" }
const _hoisted_11 = {
  key: 0,
  class: "error-validation pt-1"
}
const _hoisted_12 = { class: "user-card-item" }
const _hoisted_13 = {
  key: 0,
  class: "error-validation pt-1"
}
const _hoisted_14 = { class: "user-content-card-double-row" }
const _hoisted_15 = { class: "user-card-item" }
const _hoisted_16 = { class: "user-card-item" }
const _hoisted_17 = {
  key: 0,
  class: "error-validation pt-1"
}
const _hoisted_18 = {
  key: 1,
  class: "error-validation pt-1"
}
const _hoisted_19 = { class: "user-content-card-double-row" }
const _hoisted_20 = { class: "user-card-item" }
const _hoisted_21 = {
  key: 0,
  class: "error-validation pt-1"
}
const _hoisted_22 = { class: "user-card-item p-relative" }
const _hoisted_23 = {
  class: "form-text",
  style: {"color":"#adacb7"}
}
const _hoisted_24 = {
  key: 0,
  style: {"display":"flex"}
}
const _hoisted_25 = { class: "user-card-item-last" }
const _hoisted_26 = { class: "item-date-title" }
const _hoisted_27 = { class: "item-date" }
const _hoisted_28 = { class: "user-card-item-last" }
const _hoisted_29 = { class: "user-card-item-active" }
const _hoisted_30 = { class: "user-edit-footer" }
const _hoisted_31 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-save fs-20 d-block" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.id > 0 ? _ctx.$t('settings.edit-user') : _ctx.$t('settings.new-agency-user')), 1),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, _toDisplayString(_ctx.userNameTitle), 1),
        _createVNode("div", _hoisted_6, [
          _createVNode("form", _hoisted_7, [
            _hoisted_8,
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _createVNode("label", null, _toDisplayString(_ctx.$t('label.first-name')) + ":", 1),
                _withDirectives(_createVNode("input", {
                  maxlength: "30",
                  onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.checkLength('fname'))),
                  type: "text",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.user.firstName = $event)),
                  class: { 'border-red': !_ctx.user.firstName && _ctx.saveWas }
                }, null, 34), [
                  [_vModelText, _ctx.user.firstName]
                ]),
                (!_ctx.user.firstName && _ctx.saveWas)
                  ? (_openBlock(), _createBlock("div", _hoisted_11, _toDisplayString(_ctx.$t('valid.isRequired')), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_12, [
                _createVNode("label", null, _toDisplayString(_ctx.$t('label.last-name')) + ":", 1),
                _withDirectives(_createVNode("input", {
                  maxlength: "30",
                  onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.checkLength('lname'))),
                  type: "text",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.user.lastName = $event)),
                  class: { 'border-red': !_ctx.user.lastName && _ctx.saveWas }
                }, null, 34), [
                  [_vModelText, _ctx.user.lastName]
                ]),
                (!_ctx.user.lastName && _ctx.saveWas)
                  ? (_openBlock(), _createBlock("div", _hoisted_13, _toDisplayString(_ctx.$t('valid.isRequired')), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _createVNode("label", null, _toDisplayString(_ctx.$t('label.mobile')) + ":", 1),
                _withDirectives(_createVNode("input", {
                  type: "text",
                  onKeypress: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isTelephone($event))),
                  onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.additionalValidation && _ctx.additionalValidation(...args))),
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.user.mobile = $event)),
                  class: { 'border-red': (_ctx.wrongMobile) && _ctx.saveWas }
                }, null, 34), [
                  [_vModelText, _ctx.user.mobile]
                ])
              ]),
              _createVNode("div", _hoisted_16, [
                _createVNode("label", null, _toDisplayString(_ctx.$t('label.email')) + ":", 1),
                _withDirectives(_createVNode("input", {
                  type: "email",
                  onInput: _cache[8] || (_cache[8] = ($event: any) => ((_ctx.wrongEmail = false), (_ctx.emailExist = false))),
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.user.email = $event)),
                  class: { 'border-red': (_ctx.emailExist || _ctx.wrongEmail || !_ctx.user.email) && _ctx.saveWas }
                }, null, 34), [
                  [_vModelText, _ctx.user.email]
                ]),
                (!_ctx.user.email && _ctx.saveWas)
                  ? (_openBlock(), _createBlock("div", _hoisted_17, _toDisplayString(_ctx.$t('valid.isRequired')), 1))
                  : _createCommentVNode("", true),
                (_ctx.emailExist)
                  ? (_openBlock(), _createBlock("div", _hoisted_18, _toDisplayString(_ctx.$t('wrong.email-exist')), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_19, [
              _createVNode("div", _hoisted_20, [
                _createVNode("label", null, _toDisplayString(_ctx.$t('title.username')) + ":", 1),
                _withDirectives(_createVNode("input", {
                  type: "text",
                  onInput: _cache[10] || (_cache[10] = ($event: any) => ((_ctx.wrongUsername = false), (_ctx.usernameExist = false))),
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.user.userName = $event)),
                  class: { 'border-red': (_ctx.usernameExist || _ctx.wrongUsername) && _ctx.saveWas },
                  autocomplete: "off"
                }, null, 34), [
                  [_vModelText, _ctx.user.userName]
                ]),
                (_ctx.usernameExist)
                  ? (_openBlock(), _createBlock("div", _hoisted_21, _toDisplayString(_ctx.$t('wrong.username-exist')), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_22, [
                _createVNode("label", null, _toDisplayString(_ctx.$t('title.password')) + ":", 1),
                _withDirectives(_createVNode("input", {
                  class: ["pr40", { 'border-red': !_ctx.passwordIsValid && _ctx.saveWas }],
                  type: _ctx.passwordFieldType,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.user.password = $event)),
                  autocomplete: "off"
                }, null, 10, ["type"]), [
                  [_vModelDynamic, _ctx.user.password]
                ]),
                _createVNode("small", _hoisted_23, _toDisplayString(_ctx.$t('providerDetails.User.passwordRequirements')), 1),
                _createVNode("i", {
                  class: ["icon-f fs-28 hide-show-pass", _ctx.passwordFieldType === 'password' ? 'icon-eye' : 'icon-eye-hide'],
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.passwordFieldType = _ctx.passwordFieldType === 'password' ? 'text' : 'password'))
                }, null, 2)
              ])
            ]),
            (_ctx.id > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_24, [
                  _createVNode("div", _hoisted_25, [
                    _createVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('label.created-date')), 1),
                    _createVNode("div", _hoisted_27, _toDisplayString(_ctx.getCreateDateFormat(_ctx.user.createdAt)), 1)
                  ]),
                  _createVNode("div", _hoisted_28, [
                    _createVNode("div", _hoisted_29, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('title.active')), 1),
                      _createVNode("input", {
                        onClick: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleActivation && _ctx.toggleActivation(...args)), ["stop"])),
                        type: "checkbox",
                        class: "toggle ml-15",
                        checked: _ctx.user.active
                      }, null, 8, ["checked"])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_30, [
        _createVNode("button", {
          class: "cancel",
          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.cancel()))
        }, _toDisplayString(_ctx.$t('button.cancel')), 1),
        _createVNode("button", {
          class: "save",
          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.save()))
        }, [
          _hoisted_31,
          _createTextVNode(_toDisplayString(_ctx.$t('button.save')), 1)
        ])
      ])
    ])
  ]))
})